import * as Yup from "yup";

const Validation = Yup.object().shape({
  roundType: Yup.number()
    .typeError("Round Type must be a number")
    .min(1, "Minimum value is 1")
    .required("Round Type is required"),
  energySpent: Yup.number()
    .typeError("Energy Spent must be a number")
    .min(1, "Minimum value is 1")
    .required("Energy Spent is required"),
  btncRewardReceived: Yup.number()
    .typeError("BTNc Reward Received must be a number")
    .min(1, "Minimum value is 1")
    .required("BTNc Reward Received is required"),
  coinRewardReceived: Yup.number()
    .typeError("Coin Reward Received must be a number")
    .min(1, "Minimum value is 1")
    .required("Coin Reward Received is required"),
  jackpotRewardReceived: Yup.number()
    .typeError("Jackpot Reward Received must be a number")
    .min(1, "Minimum value is 1")
    .required("Jackpot Reward Received is required"),
  leaderboardPointsEarned: Yup.number()
    .typeError("Leaderboard Points Earned must be a number")
    .min(1, "Minimum value is 1")
    .required("Leaderboard Points Earned is required"),
  shortDescription: Yup.string().required("Short Description is required"),
});

export default Validation;